import { gql } from "@apollo/client";

export const UPDATE_COHORT_ENROLLMENT_MUTATION = gql`
  mutation UpdateCohortEnrollment($input: BackofficeEducationUpdateCohortEnrollmentInput!) {
    updateCohortEnrollment(input: $input) {
      code
      success
      message
      cohortEnrollment {
        id
        status
        universityCohort {
          id
          name
        }
        person {
          id
          firstName
          lastName
        }
      }
    }
  }
`;

export const CREATE_GRADUATION_REQUESTS_MUTATION = gql`
  mutation CreateGraduationRequests($input: BackofficeEducationCreateGraduationRequestInput!) {
    createGraduationRequests(input: $input) {
      success
      message
      graduationRequests {
        id
        graduationDate
        status
        submittedBy {
          id
          name
          email
        }
        processedBy {
          id
          name
          email
        }
        processedAt
        rejectionReason
      }
    }
  }
`;
